<template>
  <div class="left-bar-dod-element-wrapper" @click="handleClickRedirect">
    <img v-if="name === 'Zadania'" src="../icons/taskDodIcon.svg" alt="" />
    <img
      v-else-if="name === 'Niepełny grafik'"
      src="../icons/calendarDodIcon.svg"
      alt=""
    />
    <img
      v-else-if="name === 'Nowe zlecenie'"
      src="../icons/documentsDodIcon.svg"
      alt=""
    />
    <img
      v-else-if="name === 'Rozpoznanie terenu'"
      src="../icons/eyeDodIcon.svg"
      alt=""
    />
    <img
      v-else-if="name === 'W realizacji'"
      src="../icons/reloadDodIcon.svg"
      alt=""
    />
    <img
      v-else-if="name === 'Wymaga uwagi'"
      src="../icons/smallEyeDodIcon.svg"
      alt=""
    />
    <img
      v-else-if="name === 'Zawieszone'"
      src="../icons/stoperDodIcon.svg"
      alt=""
    />
    <img
      v-else-if="name === 'Archiwum/rezygnacja'"
      src="../icons/archiveDodIcon.svg"
      alt=""
    />

    <img
      v-else-if="name === 'Aplikacja'"
      src="../icons/peopleHeartIcon.svg"
      alt=""
    />
    <img
      v-else-if="name === 'Z możliwością roz. pracy'"
      src="../icons/wavingPeopleIcon.svg"
      alt=""
    />
    <img
      v-else-if="name === 'Umowa podpisana'"
      src="../icons/checkMarkDodIcon.svg"
      alt=""
    />
    <img
      v-else-if="name === 'Zawieszona'"
      src="../icons/dangerDodIcon.svg"
      alt=""
    />
    <img
      v-else-if="name === 'Do rozwiązania'"
      src="../icons/warningDodIcon.svg"
      alt=""
    />
    <img
      v-else-if="name === 'Rozwiązanie umowy'"
      src="../icons/binDodIcon.svg"
      alt=""
    />

    <img v-else src="../icons/default.svg" alt="" />
    <span :class="`${isActive ? 'pink-text' : ''}`">{{ name }}</span>
    <span class="quantity-span" v-show="statusesCounters">{{
      statusesCounters[name] || 0
    }}</span>
  </div>
</template>

<script>
export default {
  props: ["name", "section", "status"],
  data() {
    return {
      isActive: false,
    };
  },
  methods: {
    handleClickRedirect() {
      this.$store.dispatch("setSelectedLeftBarLink", this.name);
      if (this.section === "task") {
        this.$router.push({
          name: "DodTasksList",
          query: {
            type: this.name.toLowerCase().replace(" ", "_"),
          },
        });
      } else if (this.section === "customer") {
        this.$store.dispatch("setSelectedCustomerStatus", this.status);
        this.$router.push({
          name: "Customers",
          query: {
            status: this.status ? this.status.id : "",
            notScheduled: this.status ? 0 : 1,
            type: this.name.toLowerCase().replace(" ", "_"),
          },
        });
      } else {
        this.$store.dispatch("setSelectedEmployeeStatus", this.status);
        this.$router.push({
          name: "Employees",
          query: { status: this.status.id },
          type: this.name.toLowerCase().replace(" ", "_"),
        });
      }
    },
  },

  watch: {
    selectedLeftBarLink() {
      if (this.selectedLeftBarLink === this.name) {
        this.isActive = true;
      } else {
        this.isActive = false;
      }
    },
  },
  created() {
    if (this.name.toLowerCase().replace(" ", "_") === this.$route.query.type) {
      this.isActive = true;
    }
  },

  computed: {
    customerStatuses() {
      return this.$store.getters.getCustomerStatuses;
    },
    employeeStatuses() {
      return this.$store.getters.getEmployeeStatuses;
    },
    selectedLeftBarLink() {
      return this.$store.getters.getSelectedLeftBarLink;
    },
    statusesCounters() {
      return this.$store.getters.getStatusesCounters;
    },
  },
};
</script>

<style scoped>
.left-bar-dod-element-wrapper {
  display: flex;
  align-items: center;
  font-size: 12px;
  cursor: pointer;
}
.left-bar-dod-element-wrapper img {
  width: 24px;
  height: 24px;
  margin-right: 15px;
}
span {
  max-width: 95px;
  overflow-wrap: break-word;
}
.quantity-span {
  display: block;
  padding: 5px 9px;
  margin-left: auto;
  border-radius: 16px;
  color: #090741;
  font-weight: 700;
  text-align: center;
  background-color: #f2f2f5;
}

.pink-text {
  color: #e2037e;
  font-weight: 700;
}
</style>
